import React from 'react';

/**
 * CpscTable — CHA-230. Shared shell for the CPSC data tables (standard `bg-slate-50 text-slate-500`
 * head + row divider) that were hand-rolled across the CPSC surfaces. Callers pass
 * a `columns` array of header-cell descriptors and supply their own `<tr>` rows as children, so adopting
 * it is byte-identical to the prior markup (per-column + per-table class overrides are all pass-through).
 * CHA-278 — the Carbon pass restyles via the pass-through overrides (callers pass the mono-uppercase
 * `CPSC_TH_CLASS` head); the legacy default head stays for any non-reskinned caller.
 */
export const CPSC_ROW_CLASS = 'border-t border-carbon-gray-10';
// CHA-278 — the canonical Carbon table head (Orders/Modules concept): mono uppercase eyebrows on #F4F4F4.
export const CPSC_TH_CLASS = 'bg-carbon-gray-10 font-plex-mono text-[10px] tracking-[0.12em] uppercase font-normal text-carbon-gray-50 border-b border-carbon-border';

export default function CpscTable({
  columns = [],
  children,
  className = 'w-full text-sm',
  headClassName = 'bg-slate-50 text-slate-500',
  headRowClassName = '',
}) {
  return (
    <table className={className}>
      <thead className={headClassName}>
        <tr className={headRowClassName || undefined}>
          {columns.map((col, i) => (
            <th key={col.key ?? i} className={col.className}>{col.label}</th>
          ))}
        </tr>
      </thead>
      <tbody>{children}</tbody>
    </table>
  );
}
